import { useMissionStore } from "@/store/modules/mission";

export default () => {
  return async (to, from, next) => {
    try {
      const missionStore = useMissionStore();
      const currentDashboardUuid = missionStore.currentMission.dashboardUuid;
      await missionStore.retrieveMissionDashboard(currentDashboardUuid);
      return next();
    } catch (err) {
      console.log(err);
      return next();
    }
  };
};
